import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

import { getApiSingleDetails } from '../../modules/utils';

import exclamation from '../../assets/images/exclamation_triangle.svg';

import { fetchLogOutDetail } from '../../redux/actions/user/logOutDetail';
import { useDispatch, useSelector } from 'react-redux';

const LogoutPopup = ({ isOpen, toggle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();

  const { logOutDetailReducer = [] } = useSelector((state) => ({
    logOutDetailReducer: getApiSingleDetails(state.logOutDetailReducer.data),
  }));

  const [matches, setMatches] = useState('');
  const [amount, setAmount] = useState('');

  useEffect(() => {
    dispatch(fetchLogOutDetail()).then(() => {
      // setMatches(logOutDetailReducer?.matchCount);
      // setAmount(logOutDetailReducer?.totalAmount);
    });
  }, []);
  useEffect(() => {
    setMatches(logOutDetailReducer?.matchCount);
    setAmount(logOutDetailReducer?.totalAmount);
  }, [logOutDetailReducer]);
  const doLogout = () => {
    keycloak.logout({
      redirectUri: window.origin,
    });
    window.localStorage.clear();
  };
  const reviewMatches = () => {
    toggle();
    navigate('/my-active-matches');
  };
  return (
    <Modal isOpen={isOpen} centered={true} fade={false} className="logout-modal">
      <ModalBody>
        <div className="row">
          <div className="col-md-12 mx-auto">
            <p className="text-center mt-5">
              <img src={exclamation} width="150px" alt="exclamation" />
            </p>
            <p className="bebas-font font48 text-center mb-1">Log out?</p>
            {logOutDetailReducer?.matchCount > 0 && (
              <p className="font14 font-bold text-center mb-5">
                You currently have {matches} matches for a total of {amount} in progress. Are you
                sure you want to log out?
              </p>
            )}

            {logOutDetailReducer?.matchCount === 0 && (
              <p className="font14 font-bold text-center mb-5">Powering it down for the night?</p>
            )}

            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group mb-5">
                {logOutDetailReducer?.matchCount === 0 && (
                  <button
                    type="button"
                    className="btn btn-block btn-outline-primary mb-3 tab-btn"
                    onClick={toggle}
                  >
                    Nope, Not Yet!
                  </button>
                )}
                <button type="button" data-testid="log-out-confirm-button" className="btn btn-block mb-3 tab-btn" onClick={doLogout}>
                  Yes, Log Out
                </button>
                {logOutDetailReducer?.matchCount > 0 && (
                  <button
                    type="button"
                    className="btn btn-block mb-1 tab-btn active"
                    onClick={reviewMatches}
                  >
                    Review Matches
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LogoutPopup;
